<template>
    <div
            v-if="!eventListen || isOpen"
            class="popup popup-blur popup-open popup-auto-width"
            :class="{ 'with-twentytwenty': previewImageInternal && compareImageInternal }"
    >
        <div class="popup-backdrop image canClose" @click="close">
            <div class="icon icon-close-dark pointer canClose close" title="schließen" @click="close"></div>
            <div v-if="!imageGallery" class="container-image flex flex-center center">
                <TwentyTwenty
                        :style="twentyTwentyStyle"
                        v-if="compareImageInternal"
                        :before="previewImageInternal.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|avif)$/i, '.webp')"
                        :after="compareImageInternal.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|avif)$/i, '.webp')"
                        @click="close"
                />
                <picture v-else-if="!compareImageInternal && previewImageInternal">
                    <source
                            type="image/avif"
                            :srcset="previewImageInternal.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|webp)$/i, '.avif')"
                    />
                    <img
                            type="image/webp"
                            alt
                            loading="lazy"
                            :src="previewImageInternal.replace(/\.(jpg|jpeg|png|gif|bmp|tiff|avif)$/i, '.webp')"
                    />
                </picture>
                <video v-else-if="videoUrlInternal" ref="video" controls>
                    <source :src="videoUrlInternal"/>
                </video>
            </div>
            <div ref="swiperContainer" v-if="imageGallery" @click="close" class="canClose swiper popup-gallery-swiper">
                <div class="swiper-wrapper canClose" @click="close">
                    <div v-for="(image, i) in imageGallery" :key="i" class="swiper-slide canClose" @click="close">
                        <div
                                class="figure-container canClose"
                                @mouseover="mouseOverHandler"
                                @mouseout="mouseOutHandler"
                                @touchstart="mouseOverHandler"
                                @touchend="mouseOutHandler"
                        >
                            <TwentyTwenty
                                    v-if="image.imageBefore"
                                    offset="0.5"
                                    :before="
                                    image.imageBefore.match(/\.gif$/i)
                                        ? image.imageBefore
                                        : image.imageBefore.replace(/\.(jpg|jpeg|png|bmp|tiff|avif)$/i, '.webp')
                                "
                                    :after="
                                    image.imageAfter.match(/\.gif$/i)
                                        ? image.imageAfter
                                        : image.imageAfter.replace(/\.(jpg|jpeg|png|bmp|tiff|avif)$/i, '.webp')
                                "
                            />
                            <picture v-else>
                                <source
                                        type="image/avif"
                                        :srcset="
                                        image.single.match(/\.gif$/i)
                                            ? image.single
                                            : image.single.replace(/\.(jpg|jpeg|png|bmp|tiff|webp)$/i, '.avif')
                                    "
                                />
                                <img
                                        type="image/webp"
                                        :alt="image.caption ? image.caption : ''"
                                        loading="lazy"
                                        :src="
                                        image.single.match(/\.gif$/i)
                                            ? image.single
                                            : image.single.replace(/\.(jpg|jpeg|png|bmp|tiff|avif)$/i, '.webp')
                                    "
                                />
                            </picture>
                            <div class="slide-caption" v-if="image.caption">{{ image.caption }}</div>
                        </div>
                    </div>
                </div>
                <div class="popup-gallery-swiper-button-next"></div>
                <div class="popup-gallery-swiper-button-prev"></div>
            </div>
        </div>
    </div>
</template>

<script>
import TwentyTwenty from "vue-twentytwenty-one"
import Swiper from "swiper"
import { Navigation } from "swiper/modules"

Swiper.use([Navigation])

export default {
    props: ["preview-image", "compare-image", "event-listen", "preview-video"],
    components: {TwentyTwenty},
    data() {
        return {
            isOpen: false,
            imgCompare: false,
            imageGallery: false,
            currentGalleryIndex: -1,
            previewImageInternal: false,
            compareImageInternal: false,
            videoUrlInternal: false,
            swiperInstance: null
        }
    },
    mounted() {
        document.querySelectorAll(".card-with-video").forEach(card => {
            card.addEventListener("click", () => {
                const videoUrl = card.dataset.videoUrl
                if (videoUrl) window.eventBus?.$emit("exampleVideo", videoUrl)
            })
        })
    },
    created() {
        this.previewImageInternal = this.previewImage || false
        this.compareImageInternal = this.compareImage || false
        this.videoUrlInternal = this.previewVideo || false
        window.addEventListener("keydown", this.keyDown, {passive: true})

        if (this.eventListen) {
            this.$root.$on("exampleImage", (previewImage, compareImage) => {
                this.reset()
                this.previewImageInternal = previewImage
                this.compareImageInternal = compareImage
                const imgCompare = new Image()
                imgCompare.onload = () => (this.isOpen = true)
                imgCompare.src = this.compareImageInternal
            })

            window.eventBus?.$on("exampleVideo", (videoUrl) => {
                this.reset()
                this.videoUrlInternal = videoUrl
                this.isOpen = true
                this.$nextTick(() => this.$refs.video?.play?.())
            })

            window.eventBus?.$on("imageGallery", ({imageGallery, currentGalleryIndex}) => {
                this.reset()
                this.imageGallery = imageGallery
                this.currentGalleryIndex = currentGalleryIndex
                this.previewImageInternal =
                    this.imageGallery[currentGalleryIndex]?.single ?? this.imageGallery[currentGalleryIndex]?.imageBefore
                this.isOpen = true
                this.$nextTick(() => this.initializeSwiper())
            })
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal && this.swiperInstance) {
                this.swiperInstance.destroy(true, true)
                this.swiperInstance = null
            }
        }
    },
    computed: {
        twentyTwentyStyle() {
            return this.getTwentyTwentyStyles()
        }
    },
    methods: {
        initializeSwiper() {
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true) // Destroy previous instance if exists
            }
            this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                initialSlide: this.currentGalleryIndex,
                speed: 600,
                navigation: {
                    nextEl: ".popup-gallery-swiper-button-next",
                    prevEl: ".popup-gallery-swiper-button-prev"
                }
            })
            this.swiperInstance.on("slideChange", () => {
                const resizeEvent = new Event("resize")
                setTimeout(() => window.dispatchEvent(resizeEvent), 650)
            })
        },
        reset() {
            this.previewImageInternal = false
            this.compareImageInternal = false
            this.videoUrlInternal = false
            this.imageGallery = false
            this.currentGalleryIndex = -1
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true)
                this.swiperInstance = null
            }
        },
        close(event) {
            if (event.target.tagName === "BODY" || event.target.classList.contains("canClose")) {
                if (this.swiperInstance) {
                    this.swiperInstance.destroy(true, true)
                    this.swiperInstance = null
                }
                event.stopPropagation()
                this.isOpen = false
                this.$emit("close")
                this.reset()
            }
        },
        keyDown(event) {
            const key = event.key
            if (key === "Escape") {
                this.close(event)
                event.preventDefault()
            } else if (key === "ArrowLeft" || key === "ArrowRight") {
                if (key === "ArrowLeft" && this.swiperInstance) {
                    this.swiperInstance.slidePrev()
                } else if (key === "ArrowRight" && this.swiperInstance) {
                    this.swiperInstance.slideNext()
                }
            }
        },
        mouseOutHandler(e) {
            if (e.currentTarget.querySelector(".twentytwenty-container")) {
                this.swiperInstance.allowTouchMove = true
            }
        },
        mouseOverHandler(e) {
            if (e.currentTarget.querySelector(".twentytwenty-container")) {
                this.swiperInstance.allowTouchMove = false
            }
        },
        getTwentyTwentyStyles() {
            let {width, height} = this.imgCompare?.target || {}
            const maxWidth = Math.min(1200, (document.documentElement.clientWidth || window.innerWidth) * 0.8)
            const maxHeight = Math.min(750, (document.documentElement.clientHeight || window.innerHeight) * 0.8)
            const isApplyWidth = width - maxWidth > height - maxHeight
            if (isApplyWidth && width > maxWidth) {
                const ratio = width / height
                width = maxWidth
                height = width / ratio
            } else if (!isApplyWidth && height > maxHeight) {
                const ratio = height / width
                height = maxHeight
                width = height / ratio
            }
            return `position: relative; width: ${width}px; height: ${height}px; max-height: 100%; max-width: 100%;`
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@sass/components/image-view";
</style>
